module.exports = __webpack_public_path__ + "img/elasticbitcoin-A-NEW-DEFI-PROTOCOL.83b7827f.svg";